export default "__VITE_ASSET__C9OYD2Yi__"